import React, { Component } from "react";
import { connect } from "react-redux";
import { Wrapper } from "app/NativeComponents/common";

import PayNowCard from "./PayNowCard";
import AddressInfo from "./AddressInfo";
import CardInfo from "./CardInfo";
import MoreInfo from "./MoreInfo";

import {
  /*mobile*/
  appRedirect,
  saveCard,
  getBilling,
  updatePlan,
  loadPlans
} from "app/NativeActions";

class PaymentPage extends Component {
  constructor(props) {
    super(props);

    const {
      user: {
        address,
        address2,
        address_city,
        address_state,
        address_zip,
        firstname,
        lastname,
        team_email
      }
    } = props;
    const billing_address = {
      name: [firstname, lastname].join(" ") || "",
      address: address || "",
      address2: address2 || "",
      city: address_city || "",
      state: address_state || "",
      zip: address_zip || "",
      email: team_email || ""
    };

    const { selected_engines, colors } = props;

    let plan_slug = props.engine_slug;
    switch (parseInt(props.tier)) {
      case 1:
        plan_slug += "_basic";
        break;
      case 2:
      default:
        plan_slug += "_professional";
        break;
      case 3:
        plan_slug += "_enterprise";
        break;
    }

    this.state = {
      engine_slug: props.engine_slug,
      tier: props.tier,
      frequency: props.frequency,

      extra_fee: props.extra_fee,
      extra_fee_text: props.extra_fee_text,
      plan_slug,
      editing_card:
        this.addressCompleted(billing_address) &&
        !this.cardCompleted(props.card_info)
          ? true
          : false,
      editing_address: this.addressCompleted(billing_address) ? false : true,
      address: billing_address,
      plan_info: null,
      plan_info_loading: true
    };

    this.editAddressField = this.editAddressField.bind(this);
    this.toggleEditAddress = this.toggleEditAddress.bind(this);
    this.addressCompleted = this.addressCompleted.bind(this);

    this.toggleEditCard = this.toggleEditCard.bind(this);
    this.cardCompleted = this.cardCompleted.bind(this);

    this.saveCard = this.saveCard.bind(this);
    this.completePurchase = this.completePurchase.bind(this);
  }

  getData(slug) {
    loadPlans(slug)
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState({ plan_info: data.items[0] });
        }
        this.setState({ plan_info_loading: false });
      })
      .catch(err => {
        this.setState({ plan_infoloading: false });
      });
  }

  componentDidMount() {
    const {
      engine_slug,
      tier,
      frequency,
      plan_slug,
      extra_fee,
      extra_fee_text
    } = this.state;
    this.props.getBilling({
      token: this.props.token,
      type: "estimated_payment",
      selected_street: engine_slug == "driving" ? 1 : 0,
      street_selected_tier: tier,
      street_selected_frequency: frequency,

      selected_lists: engine_slug == "lists" ? 1 : 0,
      lists_selected_tier: tier,
      lists_selected_frequency: frequency,

      selected_messages: engine_slug == "messages" ? 1 : 0,
      messages_selected_tier: tier,
      messages_selected_frequency: frequency,

      extra_fee,
      extra_fee_text
    });

    if (plan_slug) {
      this.getData(plan_slug);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.card_info && this.props.card_info !== prevProps.card_info) {
      if (this.cardCompleted(this.props.card_info) && this.state.editing_card) {
        this.toggleEditCard(false);
      }
    }
  }

  editAddressField({ prop, value }) {
    this.setState({
      address: {
        ...this.state.address,
        [prop]: value
      }
    });
  }
  toggleEditAddress(editing_address) {
    this.setState({
      editing_address
    });

    if (!editing_address && !this.cardCompleted(this.props.card_info)) {
      this.toggleEditCard(true);
    } else if (editing_address) {
      this.toggleEditCard(false);
    }
  }

  addressCompleted(address) {
    if (
      address &&
      !!address.name &&
      !!address.address &&
      !!address.city &&
      !!address.state &&
      !!address.zip &&
      address.zip.length == 5
    ) {
      return true;
    }

    return false;
  }

  toggleEditCard(editing_card) {
    this.setState({
      editing_card
    });
  }

  cardCompleted(card_info) {
    if (
      card_info.has_card == 1 &&
      card_info.dealcredit_bad_card != 1 &&
      card_info.bad_card != 1 &&
      !!card_info.last4
    ) {
      return true;
    }
    return false;
  }

  saveCard(card_token, error) {
    const { token, card, platform } = this.props;
    const { address } = this.state;
    if (card_token || error) {
      this.props.saveCard({
        token: token,
        card_token: card_token,
        error: error,
        type: "confirm_payment_update_card",
        device: platform,
        address: address,
        email: address.email
      });
    } else {
      const { number, expMonth, expYear, cvc } = card;
      this.props.saveCard({
        token: token,
        number,
        expMonth,
        expYear,
        cvc,
        type: "confirm_payment_update_card",
        device: platform,
        address: address,
        email: address.email
      });
    }
  }

  completePurchase() {
    const {
      editing_card,
      editing_address,
      engine_slug,
      tier,
      frequency,
      extra_fee,
      extra_fee_text
    } = this.state;
    const { token, card_info, platform, onSuccess = null } = this.props;
    if (!editing_card && !editing_address && this.cardCompleted(card_info)) {
      this.props.updatePlan({
        token: token,
        type: "select_plans",
        device: platform,

        selected_street: engine_slug == "driving" ? 1 : 0,
        street_selected_tier: tier,
        street_selected_frequency: frequency,
        street_extra_fee: extra_fee,
        street_extra_fee_text: extra_fee_text,

        selected_lists: engine_slug == "lists" ? 1 : 0,
        lists_selected_tier: tier,
        lists_selected_frequency: frequency,
        lists_extra_fee: extra_fee,
        lists_extra_fee_text: extra_fee_text,

        selected_messages: engine_slug == "messages" ? 1 : 0,
        messages_selected_tier: tier,
        messages_selected_frequency: frequency,
        messages_extra_fee: extra_fee,
        messages_extra_fee_text: extra_fee_text,
        onSuccess
      });
    }
  }

  render() {
    const {
      user,
      isMobile,
      colors,
      states,
      loading,
      card_info,
      estimated_payment,
      loading_estimated_payment
    } = this.props;
    const {
      engine_slug,
      tier,
      frequency,
      plan_slug,
      plan_info,
      address,
      editing_address,
      editing_card
    } = this.state;
    return (
      <Wrapper>
        <Wrapper style={{ flexDirection: isMobile ? "column" : "row" }}>
          <Wrapper style={{ flex: 1, padding: 20 }}>
            <AddressInfo
              address={address}
              states={states}
              colors={colors}
              editing_card={editing_card}
              editing_address={editing_address}
              editAddressField={this.editAddressField}
              toggleEditAddress={this.toggleEditAddress}
              addressCompleted={this.addressCompleted}
            />
            <CardInfo
              colors={colors}
              editing_address={editing_address}
              editing_card={editing_card}
              toggleEditCard={this.toggleEditCard}
              cardCompleted={this.cardCompleted}
              address={address}
              card_info={card_info}
              loading={loading}
              saveCard={this.saveCard}
            />
            <MoreInfo
              colors={colors}
              plan_slug={plan_slug}
              plan_info={plan_info}
            />
          </Wrapper>

          <PayNowCard
            colors={colors}
            editing_address={editing_address}
            editing_card={editing_card}
            cardCompleted={this.cardCompleted}
            addressCompleted={this.addressCompleted}
            card_info={card_info}
            address={address}
            engine_slug={engine_slug}
            estimated_payment={estimated_payment}
            loading_estimated_payment={loading_estimated_payment}
            plan_info={plan_info}
            completePurchase={this.completePurchase}
          />
        </Wrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, billing }) => {
  const { token, user } = auth;
  const { colors, states } = settings;
  const { device, isMobile, platform } = native;
  const {
    card,
    card_info,
    loading,
    estimated_payment,
    loading_estimated_payment
  } = billing;
  return {
    token,
    user,
    device,
    isMobile,
    card,
    card_info,
    loading,
    colors,
    states,
    estimated_payment,
    loading_estimated_payment
  };
};

export default connect(mapStateToProps, {
  /*mobile*/
  appRedirect,
  saveCard,
  getBilling,
  updatePlan
})(PaymentPage);
